import { html } from '../common';

const mobileMenu = () => {
	if (document.querySelector('.navigation__burger')) {
		const mobileMenuTrigger = document.querySelector('.navigation__burger');
		const donateTrigger = document.querySelector('.navigation-mobile .navigation__links a[href="#support-us"]');

		mobileMenuTrigger.addEventListener('click', () => {
			html.classList.toggle('mobile-menu--is-active');
		});

		donateTrigger.addEventListener('click', () => {
			html.classList.remove('mobile-menu--is-active');
		});
	}
};

export default mobileMenu;
